import React from "react";
import './about.css';
import AboutImg from '@images/me/about.jpg';
import CV from '@assets/hmesrarResume.pdf';
import Info from "./Info";
import { ReactComponent as FileSVG } from '@svgs/files.svg';
import { aboutData } from '@data/aboutData'

const About = () => {
    return (
        <section className="about section" id="about">
            <h2 className="section__title">About Me</h2>
            <span className="section__subtitle">My introduction</span>

            <div className="about__container container grid">
                <img src={AboutImg} alt="me" className="about__img" />

                <div className="about__data">
                    <Info />

                    <p className="about__description" dangerouslySetInnerHTML={{ __html: aboutData.about }}></p>
                
                    <a download='' href={CV} className="button button--flex">Check my Resume <FileSVG /></a>
                </div>
            </div>
        </section>
    );
}

export default About;